import moment from "moment-timezone";

import { formatDateForApi } from "./formatDateForApi";
import { formatAsTime } from "utils/datesAndTimes/formatAsTime";

export function formatForApiGetRequestIfDateOrTime(
	v: Date | moment.Duration
): string;
export function formatForApiGetRequestIfDateOrTime<T>(v: T): T;
export function formatForApiGetRequestIfDateOrTime(v: unknown) {
	if (v instanceof Date) {
		return formatDateForApi(v);
	}

	if (moment.isDuration(v)) {
		return formatAsTime(v, { includeSeconds: true });
	}

	return v;
}
